import { Moon, Sun } from 'lucide-react';
import { useTheme } from '@/contexts/ThemeContext';

export function ThemeSwitcher({ showLabel = true }: { showLabel?: boolean }) {
  const { theme, setTheme } = useTheme();
  const isDark = theme === 'dark';

  const toggleTheme = () => {
    setTheme(isDark ? 'light' : 'dark');
  };

  return (
    <button
      onClick={toggleTheme}
      className="h-9 rounded-full px-3 flex items-center gap-2 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
    >
      {isDark ? (
        <Moon className="h-4 w-4 text-slate-400" />
      ) : (
        <Sun className="h-4 w-4 text-amber-500" />
      )}
      {showLabel && (
        <span className="text-sm text-slate-700 dark:text-slate-300">
          {isDark ? 'Sombre' : 'Clair'}
        </span>
      )}
    </button>
  );
}
